import { render, staticRenderFns } from "./Endodoncia.vue?vue&type=template&id=de1d6108&scoped=true&"
import script from "./Endodoncia.vue?vue&type=script&lang=ts&"
export * from "./Endodoncia.vue?vue&type=script&lang=ts&"
import style0 from "./Endodoncia.vue?vue&type=style&index=0&id=de1d6108&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de1d6108",
  null
  
)

export default component.exports